/**
 * The room's language in its settings: one plain select, each language in its own name. What the board and the
 * page are written in follows it; a read or a page being written holds it, and the server says so.
 */
import { useState } from "react";
import { languageName, LANGUAGES } from "../../../shared/language";
import { Select } from "../../components/ui/Select";
import { useToast } from "../../components/ui/Toast";
import { api } from "../../lib/api";

export function RoomLanguage({ id, language, heard }: { id: string; language: string; heard: string | null }) {
  const toast = useToast();
  const [value, setValue] = useState(language);
  const known = LANGUAGES.some((l) => l.code === value);
  const options = [
    ...(known ? [] : [{ value, label: languageName(value) }]),
    ...LANGUAGES.map((l) => ({ value: l.code, label: l.own })),
  ];
  const change = (next: string) => {
    const was = value;
    setValue(next);
    api.webinars.setLanguage(id, next).catch((e: unknown) => {
      setValue(was);
      toast(e instanceof Error ? e.message : "That did not save. Try again.");
    });
  };
  return (
    <section className="card">
      <div className="card-h">
        <h2>Language</h2>
      </div>
      <div className="card-b">
        <Select value={value} onChange={change} options={options} ariaLabel="Language of this room" />
        {heard && heard !== value ? (
          <div className="muted small mt8">The talk was heard in {languageName(heard)}. Quotes stay as it was said.</div>
        ) : null}
      </div>
    </section>
  );
}
